import React from "react";
import { Modal, Button, withStyles } from "@material-ui/core";

export const SupplementationConfirmationModal = ({
  classes,
  title,
  text,
  submitButtonTitle,
  cancelButtonTitle,
  onSubmit,
  onCancel,
}) => {
  return (
    <Modal
      className={classes.modal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={true}
    >
      <div id="containerConfirmationModal" className={classes.modalContent}>
        <div className={classes.title}>{title}</div>
        <div className={classes.text} data-testid="Confirmation-Modal-Text">
          {text}
        </div>
        <div className={classes.buttonContainer}>
          {onCancel && (
            <Button
              id="cancel-button-modal"
              className={classes.buttonCancel}
              onClick={onCancel}
            >
              {cancelButtonTitle}
            </Button>
          )}
          {onSubmit && (
            <Button
              id="submit-button-modal"
              data-testid="Confirmation-Modal-Submit-Button"
              className={classes.buttonSubmit}
              onClick={onSubmit}
            >
              {submitButtonTitle}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

const styles = (theme) => {
  return {
    modal: {
      zIndex: "1",
      display: "flex",
      height: "100%",
      width: "100%",
    },
    title: {
      fontFamily: "Roboto",
      fontSize: "20px",
      fontWeight: 500,
      textAlign: "left",
      color: "#333",
      marginBottom: "23px",
    },
    text: {
      fontFamily: "Roboto",
      fontSize: "16px",
      lineHeight: '23px'
    },
    modalContent: {
      display: "flex",
      flexDirection: "column",
      margin: "auto",
      width: "40%",
      height: "auto",
      maxWidth: "500px",
      backgroundColor: "#ffffff",
      outline: "none",
      boxShadow: "0 2px 20px 0 rgba(0, 0, 0, 0.5)",
      borderRadius: "18px",
      padding: "32px 24px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
      padding: "35px 0px 0px 0px",
    },
    buttonCancel: {
      fontSize: "14px",
      color: theme.palette.primary.main,
      padding: "7px 22px",
      height: 36,
      border: `solid 1px ${theme.palette.primary.main}`,
    },
    buttonSubmit: {
      fontSize: "14px",
      marginLeft: "16px",
      color: "#FFFFFF",
      padding: "7px 22px",
      height: 36,
      backgroundColor: "#eb394b",
    },
  };
};

export default withStyles(styles)(SupplementationConfirmationModal);
